import LeftGroupList from "@/components/LeftGroupList";
import api from "@/api";
import SeesawImage from "@/components/subject/Seesaw/SeesawImage";
export default {
  name: "SeesawQuestionSelector",
  components: {
    SeesawImage,
    LeftGroupList
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: [],
      typeMap: {}
    };
  },
  methods: {
    onChoose(gid) {
      this.groupId = gid;
      this.fetchList();
    },
    fetchList() {
      api.getSeesawByGroupId(this.groupId).then(ret => {
        this.questions = ret.list;
      });
    },
    init() {
      api.getSeesawGroups().then(list => {
        this.groups = list;
        this.groupId = list[0].value;
        this.fetchList();
      });
    }
  },
  mounted() {
    this.init();
  }
};